import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const entVistasApi = `${baseUrl}/entidad-vistas`;

export const allEntVistasService = async (params) => {
  const res = await axios.get(entVistasApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveEntVistasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${entVistasApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(entVistasApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneEntVistasService = async (id) => {
  const res = await axios.get(`${entVistasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteEntVistasService = async (id) => {
  const res = await axios.delete(`${entVistasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
